module.exports = __webpack_public_path__ + "img/claimpucl.79d5a7bd.svg";